import { FilterKey } from '@studyportals/search-filters';
import { FilterSelectionState } from '@/filters/selection/FilterSelectionState';
import { Degree } from '@/models/Degree';
import { ISeoMetaDataInfo } from '../ISeoMetaDataInfo';
import { SeoMetaDataHandlerDefaultSort } from '../SeoMetaDataHandlerDefaultSort';

export class Area extends SeoMetaDataHandlerDefaultSort {
	protected async canHandleWithDefaultSorting(filterSelectionState: FilterSelectionState): Promise<boolean> {
		const selectionCount = this.selectionTypeCount(filterSelectionState);
		const countrySelected = await this.singleSelectionFor(FilterKey.COUNTRY, filterSelectionState);
		const areaSelected = await this.singleSelectionFor(FilterKey.AREA, filterSelectionState);

		return ((areaSelected && selectionCount === 1) || (areaSelected && countrySelected && selectionCount === 2));
	}

	protected async selfHandle(degree: Degree, filterSelectionState: FilterSelectionState): Promise<ISeoMetaDataInfo> {
		const area = this.getFilterOptionNameBy(FilterKey.AREA, filterSelectionState);
		const countryName = this.getFilterOptionNameBy(FilterKey.COUNTRY, filterSelectionState);
		const country = countryName !== '' ? `, ${countryName}` : ``;
		const location = `${area}${country}`;

		const portalName = degree.toPortalName();

		const seoInfo = {
			title: `Complete list of universities in ${area} | ${portalName}`,

			description:
				`Explore a full list of universities in ${location} on our dedicated page. ` +
				`Find your best options to study in ${area} with ${portalName}.`,
		};

		return Promise.resolve(seoInfo);
	}
}
